import Select from "./select";

class Selects {
    constructor(datos) {
        this.name = datos.name;

        const domElements = document.querySelectorAll('[name="' + this.name + '"]');
        this.selects = Array.from(domElements).map(domElement => {
            return new Select(domElement)
        });
    }

    vaciar() {
        this.selects.forEach(elemento => {
            elemento.vaciar();
        });
    }

    opciones(opciones) {
        this.selects.forEach(elemento => {
            elemento.opciones(opciones);
        });
    }

    cargando(textoCargando) {
        this.selects.forEach(elemento => {
            elemento.cargando(textoCargando);
        });
    }

}

export default Selects;